export function interpolate(input: number, inputRange: number[], outputRange: number[]): number {
	if (inputRange.length !== outputRange.length) {
		throw new Error('inputRange and outputRange must be the same length');
	}

	if (input > inputRange[0]) {
		for (let i = 0; i < inputRange.length - 1; i++) {
			if (input >= inputRange[i] && input <= inputRange[i + 1]) {
				return mapRange(input, inputRange[i], inputRange[i + 1], outputRange[i], outputRange[i + 1]);
			}
		}
	} else {
		for (let i = 0; i < inputRange.length - 1; i++) {
			if (input < inputRange[i] && input > inputRange[i + 1]) {
				return mapRange(input, inputRange[i], inputRange[i + 1], outputRange[i], outputRange[i + 1]);
			}
		}
	}

	if (input > inputRange[inputRange.length - 1]) {
		return outputRange[inputRange.length - 1];
	}
	return outputRange[0];
}

function mapRange(value: number, fromMin: number, fromMax: number, toMin: number, toMax: number) {
	return ((value - fromMin) * (toMax - toMin)) / (fromMax - fromMin) + toMin;
}
